/** Interfaces */
import { DsChartDataInterface } from '../interfaces/chart-data.interface';
import { DsChartDataSet } from '../interfaces/chart-dataset';

export class DsChartData {
  /**
   * The chart data label.
   */
  public label: string | Date = '';

  /**
   * The chart data sets.
   */
  public dataSets: DsChartDataSet[] = [];

  /**
   * Creates an instance of DsChartData.
   *
   * @param jsonData the json data
   */
  constructor(jsonData: DsChartDataInterface) {
    this.label = jsonData.label || this.label;
    this.dataSets = jsonData.dataSets || this.dataSets;
  }
}
